import React from 'react';
import Skyscraper from './components/Skyscraper';
import './styles/app.css';

function App() {
  return (
    <div className="App">
      <Skyscraper />
    </div>
  );
}

export default App;
